import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { Store, StoreModule } from '@ngrx/store';
import { SearchActions } from './search-controller/actions';
import { SearchModuleReducers } from './search-controller/reducers/root';
import { searchFeatureKey } from './search-controller/reducers/search.reducers';
import { SearchStates } from './search-controller/states';

export const searchStoreModule = StoreModule.forFeature(searchFeatureKey, SearchModuleReducers.search);

@NgModule({
    imports: [
        searchStoreModule
    ],
    exports: [],
    providers: [],
})
export class SearchModule {
    constructor(private readonly store: Store<SearchStates>) {
    }
}
